import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from '@/components/ui/button.js';
import { cn } from '@/lib/utils.js';

interface InlineErrorProps {
  message?: string;
  onRetry?: () => void;
  className?: string;
}

export function InlineError({
  message = 'Something went wrong.',
  onRetry,
  className,
}: InlineErrorProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex items-center gap-3 rounded-lg border border-[oklch(0.88_0.04_25)] bg-[oklch(0.97_0.02_25)] px-4 py-3',
        className
      )}
    >
      <AlertCircle className="h-4 w-4 shrink-0 text-[oklch(0.55_0.16_25)]" aria-hidden="true" />
      <p className="flex-1 text-sm text-[oklch(0.42_0.10_25)]">{message}</p>
      {onRetry && (
        <Button variant="secondary" size="sm" onClick={onRetry} className="shrink-0">
          <RefreshCw className="h-3.5 w-3.5 mr-1" aria-hidden="true" />
          Retry
        </Button>
      )}
    </div>
  );
}
